import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface KimChronologyFactDetailSource {
  docId: string;
  fileName: string;
  docType: string | null;
}

export interface KimChronologyFactDetail {
  id: string;
  factDateText: string | null;
  description: string | null;
  sources: KimChronologyFactDetailSource[];
}

export function useGetFactDetailsForKimChronology(
  matterId: string | null | undefined,
  subsetId: string | undefined,
  factIds: string[],
) {
  const { getFetchConfig } = useGetFetchConfig();

  return useQuery<KimChronologyFactDetail[], Error>(
    [QueryEntity.KimChronologyFactDetails, { factIds, subsetId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/subset/${subsetId}/facts/summaries`,
        getFetchConfig({ method: FetchMethod.POST, data: { factIds } }),
      );
      if (!res.ok) throw new Error('Failed to fetch fact details for Kim chronology');
      return res.json();
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!matterId && !!subsetId && factIds.length > 0,
      keepPreviousData: true,
    },
  );
}
